<template>
  <div>
    <!-- Start section one with image on right -->
    <div class="container-fluid px-0 mb-5">
      <div class="position-relative lpg-profile-cv">
        <div class="row g-0">
          <!-- left side -->
          <div class="col-12 col-md-4 col-lg-4 col-xl-3 px-4 pb-4 lpg-bg-primary ">
            <div class="d-flex justify-content-start justify-content-md-center align-items-center">
              <div class="mt-5 mb-4 me-4 text-center">
                <!-- for tag on label must equal to input file id tag -->
                <label for="lpg-file-upload" class="lpg-file-upload">
                  <img src="images/profile.png" />
                </label>
              </div>

              <section class="d-block d-md-none">
                <div class="lpg-profile-content">
                  <h2 class="mt-5 mb-2 lpg-form-title no-border no-letter-spacing">
                    {{ user.name }} {{ user.lastname }}
                  </h2>
                  <p class="lpg-help-block pt-lg-3 pb-0 pb-lg-1" v-if="user.date_of_birth">
                    Edad: {{ calculateAge }}
                  </p>
                  <div class="d-block d-md-inline-flex">
                    <div class="mb-2 text-start me-4" v-if="user.phone_number">
                      <span class="ps-0">{{ user.phone_number }}</span>
                    </div>
                    <div class="mb-2 text-break " v-if="user.email">
                      <span class="ps-0">{{ user.email }}</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div class="lpg-form lpg-form-box px-0">
              <section
                class="d-none d-md-block"
                v-if="user.fb_url || user.ig_url || user.linkedin_url"
              >
                <h2 class="mt-5 lpg-form-title ">CONTACTO</h2>
                <div class="lpg-profile-content">
                  <div class="mb-3 text-start" v-if="user.fb_url">
                    <i class="bi bi-facebook" style="font-size: 2rem"></i>
                    <a :href="user.fb_url" target="_blank">
                      <span class="ps-2">{{ user.fb_url.substring(0, 30) + '..' }}</span>
                    </a>
                  </div>
                  <div class="mb-3 text-start" v-if="user.ig_url">
                    <i class="bi bi-instagram" style="font-size: 2rem"></i>
                    <a :href="user.fb_url" target="_blank">
                      <span class="ps-2">{{ user.ig_url.substring(0, 30) + '..' }}</span>
                    </a>
                  </div>
                  <div class="mb-3 text-start" v-if="user.linkedin_url">
                    <i class="bi bi-linkedin" style="font-size: 2rem"></i>
                    <a :href="user.fb_url" target="_blank">
                      <span class="ps-2">{{ user.linkedin_url.substring(0, 30) + '..' }}</span>
                    </a>
                  </div>
                </div>
              </section>

              <section v-if="user.education.length" class="d-none d-md-block">
                <h2 class="mt-5 lpg-form-title ">Educación</h2>
                <div class="lpg-profile-content">
                  <div
                    class="card lpg-card"
                    v-for="education in user.education"
                    :key="education.id"
                  >
                    <span class="lpg-subtitle">
                      <span v-if="education.start_date">{{
                        customFormatter(education.start_date, 'yyyy')
                      }}</span>
                      <span v-if="education.finish_date">
                        -{{ customFormatter(education.finish_date, 'yyyy') }}</span
                      >
                    </span>

                    <span class="lpg-subtitle">{{
                      education.educational_institution_name_aux
                        ? education.educational_institution_name_aux
                        : education.institutionone.name
                    }}</span>

                    <span class="lpg-subtitle" v-if="education.title == ''">
                      {{ education.title }}
                    </span>
                    <span class="lpg-subtitle" v-else>
                      {{ education.degreeone.name }} {{ education.fieldone.name }}
                    </span>
                    <p class="lpg-desc" v-if="education.description">
                      {{ education.description.substring(0, 150) + '..' }}
                    </p>
                  </div>
                </div>
              </section>

              <section v-if="user.languages.length" class="d-none d-md-block">
                <h2 class="mt-5 lpg-form-title ">Idiomas</h2>

                <div class="lpg-profile-content">
                  <div class="card lpg-card" v-for="language in user.languages" :key="language.id">
                    <p class="lpg-desc">
                      {{ language.languaje.name }}
                    </p>
                    <span class="lpg-subtitle small ps-5">
                      {{ language.languajelevel.name }}
                    </span>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <!-- right side -->
          <div class="col-12 col-md col-lg text-start bg-white">
            <div class="lpg-body-side-right">
              <div class="lpg-form lpg-form-box px-0">
                <section class="d-none d-md-block">
                  <div class="lpg-profile-content">
                    <h2 class="mt-5 mb-2 lpg-form-title no-border no-letter-spacing">
                      {{ user.name }} {{ user.lastname }}
                    </h2>
                    <p class="lpg-help-block pb-3"></p>
                    <p class="lpg-help-block pt-3 pb-1" v-if="user.date_of_birth">
                      Edad: {{ calculateAge }}
                    </p>
                    <div class="d-inline-flex gap-4">
                      <div class="mb-2 text-start me-4" v-if="user.phone_number">
                        <i class="bi bi-telephone-fill" style="font-size: 2rem"></i>
                        <span class="ps-2">{{ user.phone_number }}</span>
                      </div>

                      <div class="mb-2 text-start">
                        <i class="bi bi-envelope" style="font-size: 2rem"></i>
                        <span class="ps-2">{{ user.email }}</span>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <h2 class="mt-5 lpg-form-title ">InformaciÓn adicional</h2>
                  <div class="lpg-profile-content">
                    <div class="card lpg-card lpg-card-white p-0 mb-3">
                      <div class="lpg-desc">
                        <ul>
                          <li v-if="user.has_driving_license == 1">
                            Licencia de vehículo:
                            <span v-if="user.has_driving_license == 1" class="span-data-adicional"
                              >Si</span
                            >
                            <span v-else class="span-data-adicional">No</span>
                          </li>
                          <li v-if="user.has_driving_license == 1">
                            Tipo de licencia de vehículo:
                            <span class="span-data-adicional">{{ user.driving_license_type }}</span>
                          </li>
                          <li>
                            Licencia de motocicleta:
                            <span
                              v-if="user.has_motorcycle_driving_license == 1"
                              class="span-data-adicional"
                              >Si</span
                            ><span v-else class="span-data-adicional">No</span>
                          </li>
                          <li>
                            Vehículo o motocicleta propia:
                            <span v-if="user.has_vehicle_ownership == 1" class="span-data-adicional"
                              >Si</span
                            ><span v-else class="span-data-adicional">No</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>
                <section v-if="user.jobExperiences.length">
                  <h2 class="mt-5 lpg-form-title ">Experiencia laboral</h2>
                  <div class="lpg-profile-content" v-for="job in user.jobExperiences" :key="job.id">
                    <div class="row">
                      <div class="col-12 col-lg-2">
                        <div
                          class="card lpg-card lpg-card-white p-0 mb-3 d-inline-block d-md-block"
                        >
                          <span class="lpg-subtitle pe-lg-0" v-if="job.start_date">
                            {{ customFormatter(job.start_date, 'MM.yyyy') }}
                          </span>
                          <span class="lpg-subtitle pe-lg-0" v-if="job.finish_date">-</span>
                          <span class="lpg-subtitle pe-lg-0" v-if="job.finish_date">
                            {{ customFormatter(job.finish_date, 'MM.yyyy') }}
                          </span>
                        </div>
                      </div>
                      <div class="col">
                        <div class="card lpg-card lpg-card-white p-0 mb-3">
                          <span class="lpg-title">
                            {{ job.job_title }}
                          </span>
                          <span class="lpg-subtitle">
                            {{ job.company_name }}
                          </span>
                          <p class="lpg-desc" v-if="job.description">
                            {{ job.description.substring(0, 150) + '..' }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="d-block d-md-none" v-if="user.education.length">
                  <h2 class="mt-5 lpg-form-title ">Educación</h2>

                  <div
                    class="lpg-profile-content"
                    v-for="education in user.education"
                    :key="education.id"
                  >
                    <div class="card lpg-card lpg-card-white">
                      <span class="lpg-subtitle">
                        <span v-if="education.start_date">{{
                          customFormatter(education.start_date, 'yyyy')
                        }}</span>
                        <span v-if="education.finish_date">
                          -{{ customFormatter(education.finish_date, 'yyyy') }}</span
                        >
                        <span>
                          education.educational_institution_name_aux ?
                          education.educational_institution_name_aux : education.institutionone.name
                        </span>
                      </span>
                      <span
                        class="lpg-subtitle"
                        v-if="education.educational_institution_name_aux != ' '"
                        >{{ education.educational_institution_name_aux }}</span
                      >
                      <span class="lpg-subtitle" v-else>{{ education.institutionone.name }}</span>
                      <span class="lpg-title" v-if="education.title == ''">
                        {{ education.title }}
                      </span>
                      <span class="lpg-title" v-else>
                        {{ education.degreeone.name }} {{ education.fieldone.name }}
                      </span>
                      <p class="lpg-desc" v-if="education.description">
                        {{ education.description.substring(0, 150) + '..' }}
                      </p>
                    </div>
                  </div>
                </section>

                <section v-if="user.languages.length" class="d-block d-md-none">
                  <h2 class="mt-5 lpg-form-title ">Idiomas</h2>
                  <div class="lpg-profile-content">
                    <div
                      class="card lpg-card lpg-card-white"
                      v-for="language in user.languages"
                      :key="language.id"
                    >
                      <p class="lpg-desc">
                        {{ language.languaje.name }}
                      </p>
                      <span class="lpg-subtitle small ps-5 lpg-lang mb-0">
                        {{ language.languajelevel.name }}
                      </span>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End section one with image on right -->
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'
import { format } from 'date-fns'

export default {
  name: 'ApplicantProfileShow',
  layout: Layout,
  props: {
    user: Object,
  },
  computed: {
    calculateAge() {
      let currentDate = new Date()
      let birthDate = new Date(this.user.date_of_birth)
      let difference = currentDate - birthDate
      let age = Math.floor(difference / 31557600000)
      return age
    },
  },
  methods: {
    customFormatter(date, formato) {
      return format(new Date(date), formato)
    },
  },
}
</script>
<style scoped>
.span-data-adicional {
  font-weight: bold;
}
.lpg-profile-content a {
  text-decoration: none !important;
  color: white !important;
}
</style>
